import { render, staticRenderFns } from "./AutoSuggestSlot.vue?vue&type=template&id=5451128c&"
import script from "./AutoSuggestSlot.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports